import React, { Component } from 'react';
import axios from 'axios';
import classnames from 'classnames';

import Loading from './Loading.jsx';

export default class SopEmailListSender extends Component {
    static defaultProps = {
        frequency: 'monthly'
    };

    state = {
        isLoading: false,
        isSending: false,
        lists: null,
        sent: null
    };

    componentWillReceiveProps = (props) => {
        if (props.frequency !== this.props.frequency) {
            this.setState({
                lists: null,
                sent: null
            });
        }
    };

    getEmailLists = (e) => {
        e.preventDefault();
        this.setState({ isLoading: true, lists: null, sent: null });
        axios.get(`/sop/create-list/${this.props.frequency}`).then((resp) => {
            this.setState({
                isLoading: false,
                lists: resp.data
            });
        });
    };

    handleSendEmail = (e) => {
        return axios
            .request({
                url: `/sop/send-reminder`,
                method: 'POST',
                data: {
                    freq_type: this.props.frequency,
                    msg_type: e.target.dataset.type,
                    users: this.state.lists.end_users
                }
            })
            .then((resp) => {
                this.setState({
                    isSending: false,
                    sent: resp.data.map((item) => item.email)
                });
            });
    };

    render = () => {
        return (
            <div>
                <div className="spaced-single">
                    <button className="button" onClick={this.getEmailLists}>
                        Create Email List
                    </button>
                </div>

                {this.state.isLoading && !this.state.lists ? <Loading /> : null}

                {this.state.lists ? (
                    <div className="row spaced-single">
                        <div className="col-12 spaced-single">
                            <button className="button" type="button" data-type="trigger" onClick={this.handleSendEmail}>
                                Send Trigger
                            </button>
                            <button
                                className="button"
                                type="button"
                                data-type="reminder"
                                onClick={this.handleSendEmail}
                            >
                                Send Reminder
                            </button>
                        </div>
                        <div className="col-6">
                            <h3>Not getting an email ({this.state.lists.excluded.length})</h3>
                            <ul className="list-flat">
                                {this.state.lists.excluded.map((email) => (
                                    <li
                                        key={email}
                                        className={classnames({
                                            'text-success': this.state.sent && this.state.sent.includes(email)
                                        })}
                                    >
                                        {email}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-6">
                            <h3>Getting an email ({this.state.lists.included.length})</h3>
                            <ul className="list-flat">
                                {this.state.lists.included.map((email) => (
                                    <li
                                        key={email}
                                        className={classnames({
                                            'text-success': this.state.sent && this.state.sent.includes(email)
                                        })}
                                    >
                                        {email}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    };
}
